<template>
  <div class="container-fluid select">
    <div class="d-flex align-items-center">
      <div class="col-md-12">
        <div class="row justify-content-center mb-5">
          <div class="col-md-12 form-title">
            Selecciona si eres
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="ml-4 mr-4">
            <div id="oval-corporate" class="oval-icon rounded-circle d-flex align-items-center mb-3" v-on:click="goTo('corporate')">
              <img src="@/assets/img/users.png" srcset="@/assets/img/phone.png" class="mx-auto d-block img-fluid icons">
            </div>
            <b-tooltip target="oval-corporate" custom-class="tooltip-class">
              Suscribe a los colaboradores de tu empresa a los beneficios por ser cliente Entel Corp
            </b-tooltip>
            <div class="label">
              Corporativo
            </div>
          </div>
          <div class="ml-4 mr-4">
            <div id="oval-employee" class="oval-icon rounded-circle d-flex align-items-center mb-3" v-on:click="goTo('employee')">
              <img src="@/assets/img/users.png" srcset="@/assets/img/users.png" class="mx-auto d-block img-fluid icons">
            </div>
            <b-tooltip target="oval-employee" custom-class="tooltip-class">
              Suscríbete a los beneficios si tu empleador es cliente Entel Corp
            </b-tooltip>
            <div class="label">
              Colaborador
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    solution: String
  },
  methods: {
    goTo (template) {
      this.$router.push({ name: template, params: { solution: this.solution }, props: true })
    }
  }
}

</script>
